import {writable} from 'svelte/store';

const data = {open: false, scroll: ''};
const menu = writable(data);

menu.getData = () => data;
menu.setData = data => {
	menu.set(data);
};

export default menu;